import React from "react";
import ScoringWrittenPage from "./ScoringWrittenPage";
import { ApplyDocumentViewItem } from "../Components/ApplyDocumentDrawer";
import { Params, useLocation, useNavigate, useParams } from "react-router-dom";
import ScoringInterviewPage from "./ScoringInterviewPage";
import { http } from "../Common/http";
import { useAuth } from "../Auth/Auth";
import { Button, Modal, Result, Spin } from "antd";
import { Content } from "antd/lib/layout/layout";
import { Messages } from "../Common/ValidateMessages";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { UseCallbackPrompt } from "../Common/UseCallbackPrompt";

const { confirm } = Modal;

export const SCORE_NOTIFICATION_KEY = "SCORE_NOTIFICATION_KEY";

export interface ScoringData {
  examinationSubjectId: string;
  scoringType: string;
  groupCreationRequiredFlag: string;
  scoringAllocationFlag: string;
  scoringStartDateTime: string;
  scoringEndDateTime: string;
  dispFlag_ExamNumber: string;
  dispFlag_Name: string;
  dispFlag_NameKana: string;
  dispFlag_Birthday: string;
  dispFlag_HighSchool: string;
  elapsedMinute: number;
  elapsedSecond: number;
  judgementUnitName: string;
  subjectName: string;
  questionContents: string;
  scoringPatternType: string;
  notes: string;
  evaluationViewPoints: EvaluationViewpoint[];
  applicants: ApplicantInfo[];
}

export interface ApplicantInfo {
  applicantId: string;
  scoringAllocationId?: string;
  examNo: string;
  sei: string;
  mei: string;
  seiKana: string;
  meiKana: string;
  birthday: string;
  highSchoolName: string;
  facePictureDocument?: ApplyDocumentViewItem;
  commonDocuments?: ApplyDocumentViewItem[];
  documents?: ApplyDocumentViewItem[];
  userScoringResult?: ScoringResult;
  scoringResults: ScoringResult[];
}

export interface EvaluationViewpoint {
  evaluationViewpointId: string;
  evaluationViewpointFlag: string;
  category: string;
  subCategory: string;
  wantToAskPower: string;
  evaluationViewpointDetailList: EvaluationViewpointDetail[];
}

export interface EvaluationViewpointDetail {
  evaluationViewpointDetailId: string;
  // evaluationValue: number;
  category?: string;
  evaluationCriteria: string;
  evaluationExample: string;
  lowScore: number;
  highScore: number;
}

export interface ScoringResult {
  scoringResultId: string;
  scoringRecordType: string;
  applicantId: string;
  userId: string;
  sei: string;
  mei: string;
  scoringStatus: string;
  absenceFlag: string;
  totalScore: number;
  comment: string;
  interviewElapsedTime: number;
  resultDetails: ScoringResultDetail[];
}
export interface ScoringResultDetail {
  scoringResultDetailId: string;
  evaluationViewpoint: string;
  evaluationViewpointDetailId: string;
  score: number;
  evaluationComment: string;
  answerOrder: string;
}
export interface SaveScoringDataRequestBean {
  examinationSubjectId: string;
  useCase: string;
  scoringPatternType: string;
  interviewElapsedTime: number;
  scoringStatus: string;
  values: SaveScoringDataItem[];
}
export interface SaveScoringDataItem {
  key: string;
  value: string;
}
export interface StartScoringResponseBean {
  error?: string;
  beginDateTime?: string;
}
export interface SaveScoringResultResponseBean {
  error?: string;
}
export const ScoringPage = () => {
  const { accessToken } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { examSubjectId, objectId } = useParams<Readonly<Params<string>>>();
  const [loading, setLoading] = React.useState(true);
  const [loadError, setLoadError] = React.useState(false);
  const [scoringData, setScoringData] = React.useState<ScoringData>();

  const [showDialog, setShowDialog] = React.useState<boolean>(false);
  // eslint-disable-next-line no-empty-pattern
  const [] = UseCallbackPrompt(showDialog);

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await http<ScoringData, any>({
        path: "/Scoring/getdata",
        method: "post",
        body: {
          examSubjectId: examSubjectId,
          objectId: objectId,
          useCase: "1",
        },
        accessToken: accessToken,
      });

      if (result.ok && result.body) {
        setScoringData(result.body);
        setLoadError(false);
      } else {
        setLoadError(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setLoadError(true);
    }
  };
  const backToBeforePage = async (needConfirm: boolean = false) => {
    if (needConfirm) {
      confirm({
        title: Messages["CON-017"],
        icon: <ExclamationCircleOutlined />,
        onOk: async () => {
          setShowDialog(false);
          await new Promise((f) => setTimeout(f, 100));
          navigate("/ScoringList", { state: state });
        },
        onCancel: () => {},
      });
    } else {
      setShowDialog(false);
      await new Promise((f) => setTimeout(f, 100));
      navigate("/ScoringList", { state: state });
    }
  };
  React.useEffect(() => {
    const doLoadData = async () => {
      await loadData();
    };
    doLoadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <Content>
      <Spin spinning={true} />
    </Content>
  ) : loadError ? (
    <Content>
      <Result
        status="500"
        title="エラーが発生しました"
        subTitle={Messages["ERR-046"]}
        extra={
          <Button
            size="large"
            type="primary"
            onClick={() => backToBeforePage()}
          >
            担当受験生一覧に戻る
          </Button>
        }
      />
    </Content>
  ) : scoringData?.scoringType === "1" ? (
    <ScoringWrittenPage
      objectId={objectId!}
      useCase={"1"}
      scoringType={"1"}
      scoringData={scoringData}
      backToBeforePage={backToBeforePage}
      setShowDialog={setShowDialog}
      // evaluations={dummyEvaluations}
      // applicants={[dummyApplicants[0]]}
    />
  ) : (
    <ScoringInterviewPage
      objectId={objectId!}
      useCase={"1"}
      scoringType={"2"}
      scoringData={scoringData!}
      backToBeforePage={backToBeforePage}
      setShowDialog={setShowDialog}
      // evaluations={dummyEvaluations}
      // applicants={dummyApplicants}
    />
  );
};
